<article class="card">
  <div class="card-header w-100 d-flex justify-content-between" [attr.data-test-id]="'card-header_' + index">
    <span
      [attr.data-test-id]="'card-header-title_' + index"
      class="d-flex align-items-center w-100 text-truncate"
      [innerHTML]="card?.header"
    ></span>
    <span
      *ngIf="getBadgeStyle().length > 0"
      [attr.data-test-id]="'card-status-badge_' + index"
      [ngClass]="getBadgeStyle()"
      >{{ card?.status | translate }}</span
    >
  </div>
  <div class="card-body">
    <div class="d-flex">
      <div *ngIf="card?.image" class="me-2">
        <app-small-profile-image
          [profileImage]="card.image"
          [accountStatus]="card.status"
          [dataTestId]="'card-image_' + index"
          [accessForAdmin]="isAdminSession"
          [link]="getLink()"
        ></app-small-profile-image>
      </div>
      <div class="text-truncate w-100">
        <div class="d-flex flex-nowrap">
          <h3 class="mb-3 text-truncate w-100 custom-title">
            <ng-container *ngIf="card.descriptionType != infoType.creatorLink">
              <span [attr.data-test-id]="'card-title_' + index">
                {{ card.title | translate }}
              </span>
            </ng-container>
            <ng-container *ngIf="card.descriptionType == infoType.creatorLink">
              <span class="text-truncate" style="display: flex; max-width: 100%">
                <span class="text-truncate" style="max-width: 40%">
                  <app-profile-link
                    [dataTestId]="'card-profile-link_' + index"
                    [status]="card.entityCreator?.accountStatus"
                    [userId]="card.entityCreator?.userId"
                    [text]="card.entityCreator?.displayName"
                    [cssStyles]="'text-truncate username fw-normal profile-link'"
                  ></app-profile-link> </span
                >&nbsp;
                <span class="text-truncate" style="max-width: 60%" [attr.data-test-id]="'card-title_' + index">
                  {{ card?.title }}
                </span>
              </span>
            </ng-container>
          </h3>
          <h3 *ngIf="card?.badge" class="ps-2">
            <span
              class="badge fw-bolder"
              [class.bg-secondary]="isMember"
              [class.bg-info]="isLeader"
              [attr.data-test-id]="'card-badge_' + index"
            >
              {{ card.badge | translate }}
            </span>
          </h3>
        </div>
        <h6
          *ngIf="card?.description"
          [ngSwitch]="card.descriptionType"
          [attr.data-test-id]="'card-description_' + index"
          class="card-text text-truncate w-100"
        >
          <ng-container *ngSwitchCase="infoType.list">
            <span
              *ngFor="let option of card.description; let isLast = last; index as j"
              [attr.data-test-id]="'card-description-option-' + index + '-' + j"
            >
              {{ option | translate }}{{ isLast ? '' : ', ' }}
            </span>
          </ng-container>
          <ng-container *ngSwitchDefault>
            <span>{{ card.description }}</span>
          </ng-container>
        </h6>
        <p *ngIf="card?.created" class="mb-0" [attr.data-test-id]="'card-date_' + index">
          {{ card.created.date | date: card.created.dateFormat }}
        </p>
      </div>
    </div>

    <ng-container *ngIf="card?.buttonHint">
      <a
        [attr.data-test-id]="'card-button_' + index"
        [routerLink]="[card.buttonRouterLink]"
        [fragment]="card.urlFragment ? card.urlFragment : undefined"
        [queryParams]="card.buttonRouterParams"
        [ngClass]="{ disabled: card.actionDisabled }"
        class="btn btn-primary mt-3 me-3 custom-card-button"
      >
        {{ card.buttonHint | translate }}
      </a>
    </ng-container>

    <button
      *ngIf="card?.actionBtnHint"
      appLongOperation
      class="btn btn-outline-primary mt-3 custom-card-action-button"
      [attr.data-test-id]="'card-action-button_' + index"
      (click)="onAction(index)"
      [disabled]="card.actionDisabled || actionDisabled"
    >
      {{ card.actionBtnHint | translate }}
    </button>
  </div>
</article>
